import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

import Loading from './components/Loading';
import reportWebVitals from './reportWebVitals';

// fontawesome
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCircleQuestion, faCopy, faSquareCheck, faSquare } from '@fortawesome/free-regular-svg-icons';
import { faHouse, faList, faChevronRight, faChevronUp, faLocationDot, faCircleXmark, faXmark, faRedo, faSort, faArrowLeftLong, faArrowRightLong, faCircleMinus, faCirclePlus, faMagnifyingGlass, faSliders, faMaximize, faMinimize, faUser } from '@fortawesome/free-solid-svg-icons';

// primereact
import PrimeReact from 'primereact/api';
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import './App.scss';

// Lazy load components
const Layout = lazy(() => import('./pages/Layout'));
const ChooseNetwork = lazy(() => import('./pages/ChooseNetwork'));
const SearchWrapper = lazy(() => import('./pages/SearchWrapper'));
const AssistedSearch = lazy(() => import('./pages/AssistedSearch'));
const QuickSearch = lazy(() => import('./pages/QuickSearch'));
const SelectSearch = lazy(() => import('./pages/SelectSearch'));
const SearchResults = lazy(() => import('./pages/SearchResults'));
const Compare = lazy(() => import('./pages/Compare'));

PrimeReact.ripple = true;

// add fontawesome icons to library
library.add(faHouse, faList, faSquareCheck, faSquare, faLocationDot, faCircleXmark, faXmark, faRedo, faSort, faMaximize, faMinimize, faUser, faArrowLeftLong, faArrowRightLong, faCircleMinus, faCirclePlus, faMagnifyingGlass, faSliders);
library.add(faCircleQuestion, faCopy, faChevronRight, faChevronUp);

// mock service worker
if (process.env.REACT_APP_ENV === 'development' && process.env.REACT_APP_MSW === true) {
  const { worker } = require('./mocks/browser')
  worker.start()
}

// Suspense fallback for lazy-loaded components
const SuspenseFallback = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
    <Loading />
  </div>
);

// router setup
const router = createBrowserRouter(
  [
    {
      path: "/",
      element: (
        <Suspense fallback={<SuspenseFallback />}>
          <Layout />
        </Suspense>
      ),
      children: [
        {
          index: true,
          element: (
            <Suspense fallback={<SuspenseFallback />}>
              <ChooseNetwork />
            </Suspense>
          ),
        },
        {
          path: ":networkName",
          children: [
            {
              index: true,
              element: (
                <Suspense fallback={<SuspenseFallback />}>
                  <SelectSearch />
                </Suspense>
              ),
            },
            {
              element: (
                <Suspense fallback={<SuspenseFallback />}>
                  <SearchWrapper />
                </Suspense>
              ),
              children: [
                {
                  path: "search",
                  element: (
                    <Suspense fallback={<SuspenseFallback />}>
                      <QuickSearch />
                    </Suspense>
                  ),
                },
                {
                  path: "results",
                  element: (
                    <Suspense fallback={<SuspenseFallback />}>
                      <SearchResults />
                    </Suspense>
                  ),
                },
                {
                  path: "compare",
                  element: (
                    <Suspense fallback={<SuspenseFallback />}>
                      <Compare />
                    </Suspense>
                  ),
                },
              ]
            },
          ]
        },
      ],
    },
  ],
  {
    basename: process.env.PUBLIC_URL,
  }
);

ReactDOM.createRoot(document.getElementById('root')).render(
  <RouterProvider router={router} />
);

reportWebVitals();